import { Box, Button, Card, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import VideoBackground from "./VideoBackground";


function HeadLine() {
  return (
    <Card
      elevation={0}
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 6, md: 12 },
        px: { xs: 2, md: 8 },
        textAlign: "center",
        backgroundColor: "black",
        borderRadius: 0,
        minHeight: "500px", // Garantir altura mínima
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <VideoBackground />
      {/* Conteúdo sobreposto ao vídeo */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            mb: 1,
            fontSize: { xs: 28, md: 40 },            
            color: "#3AC3E3",
          }}
        >
          Connectivity Infrastructure by Brothers Fiber 
        </Typography>

        <Box sx={{ maxWidth: 600, mx: "auto", mb: 4 }}>
          <Typography variant="body1" sx={{ color: "rgba(255, 255, 255, 0.85)" }}>
            We build high-performance fiber optic networks from the ground up — including directional drilling, ducting, and cable installation.

            With advanced equipment and skilled crews, we deliver fast, safe, and reliable infrastructure for today’s connectivity demands.
          </Typography>
        </Box>

        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            mb: 3,
            fontSize: { xs: 28, md: 40 },
            color: "white",
          }}
        >
          We build the foundation of tomorrow’s networks — today.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, flexWrap: "wrap" }}>
          <RouterLink to="/contact-us" style={{ textDecoration: 'none' }}>
            <Button
              variant="contained" 
              color="primary" 
              size="large"
              sx={{
                borderRadius: 12,
                px: 4,
                py: 1.5,
                fontWeight: 600,
                fontSize: '1rem',
                backgroundColor: '#3AC3E3',
                boxShadow: '0 8px 20px rgba(58, 195, 227, 0.4)',
                '&:hover': {
                  backgroundColor: '#2B8AC6',
                  boxShadow: '0 12px 25px rgba(58, 195, 227, 0.5)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Get Started
            </Button>
          </RouterLink>
          <RouterLink to="/about-us" style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              color="primary" 
              size="large"
              sx={{
                color: 'white',
                borderRadius: 12,
                px: 4,
                py: 1.5,
                fontWeight: 600,
                fontSize: '1rem',
                boxShadow: '0 8px 20px rgba(58, 195, 227, 0.4)',
                '&:hover': {
                  backgroundColor: '#2B8AC6',
                  boxShadow: '0 12px 25px rgba(58, 195, 227, 0.5)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Learn More
            </Button>
          </RouterLink>
        </Box>
      </Box>
    </Card>
  );
}

export default HeadLine;